import type { MigrationStrategies } from 'rxdb';
import type { PreviousTaskCommentsDocument } from './previousTaskComments.types';

export const previousTaskCommentsMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: PreviousTaskCommentsDocument) => {
    return oldDoc;
  },
  2: (oldDoc: PreviousTaskCommentsDocument) => {
    const newDoc = {
      ...oldDoc,
      fkClerk: oldDoc.fkClerk || null,
      clerkId: oldDoc.clerkId || null,
    };
    return newDoc;
  },
};
